import authGraphQLRequest from "utils/authGraphQLRequest";
import moment from "moment";

let prevSearchText = "";

export const getPayout = ({ page, per_page, searchTexts,filter }: any): Promise<any> => {
  return new Promise((resolve, reject) => {

    let currentPage = page;

    if (searchTexts && !prevSearchText) {
      currentPage = 1; 
    }
    prevSearchText = searchTexts || "";

    const clients =
          filter?.clients?.length > 0
            ? `[${filter.clients.map((c: string) => `"${c}"`).join(",")}]`
            : "";
    
        const gateways =
          filter?.gateways?.length > 0
            ? `[${filter.gateways.map((g: string) => `"${g}"`).join(",")}]`
            : "";

        const type =
          filter?.type?.length > 0
            ? `[${filter.type.map((g: string) => `"${g.replace("_",'-')}"`).join(",")}]`
            : "";
    
        const start_date = filter?.dates?.[0]
            ? moment(filter.dates[0]).format("YYYY-MM-DD")
            : "";
    
        const end_date = filter?.dates?.[1]
            ? moment(filter.dates[1]).format("YYYY-MM-DD")
            : "";

    let queryString = `{ 
      allFiatPayout(
        page: ${currentPage}, 
        per_page: ${per_page}, 
        searchTexts: "${searchTexts}"
        ${clients ? `, clients: ${clients}` : ""}
        ${gateways ? `, gateways: ${gateways}` : ""}
        ${type ? `, batch_type: ${type}` : ""}
        ${start_date ? `, start_date: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
        ${end_date ? `, end_date: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
      ) {
        payouts{
            id
            organizationId   
            clientId    
            batchId    
            clientName
            type 
            gatewayId
            gatewayName
            createdAt
            updatedAt
            totalTransactions
            transactions {
                createdAt
                currency
                amount
                iban
                customerId
                externalCustomerNo
                status
                message
                gatewayResponse
                paymentHistory
            }
            totalAmount
        }
      }
    }`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_all_fiat_payout'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createBatchPayout = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            createFiatBatchPayout(
                client_id: "${data.client_id}"
                organization_id: "${data.organization_id}"
                type: "${data.type}"
                file: "${data.file}"
                gateway:"${data.gateway}"
            ) {
                status
                message
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_create_fiat_batch_payout'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}